module.exports = __webpack_public_path__ + "img/noData_empty.ab777650.svg";